import React, { useEffect, useState } from 'react';
import ScoreBoard from './Scoreboard';
import ProgressBar from './ProgressBar';
import SecurityExpert from './SecurityExpert';
import CorrectAnswer from './CorrectAnswer';
import { useTranslation } from 'react-i18next';
import useGame from '../hooks/useGame';
import MultipleChoiceAnswer from './MultipleChoiceAnswer';
import SkipVideo from './SkipVideo';
import VideoFilesFullLoop from "./VideoFilesFullLoop";
import MobileVideoButton from './MobileVideoButton';
import { trackPageView } from '../helpers/gaHelper';

const Question2 = () => {
   const { PUBLIC_URL, REACT_APP_LANGUAGE } = process.env;
  const { t } = useTranslation();
  const { addScore, trackGTMEvent } = useGame();

  
  setTimeout(() => {
    var helperBtn = document.querySelector('.helper-button');
    helperBtn.classList.add('question2')
  }, 100);

  useEffect(() => {
    trackPageView('/question/2');
  },[]);

  // wait
  async function wait(ms) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

  const [hasAnswered, setHasAnswered] = useState(false);
  const [score, setScore] = useState(4);

  const addBodyClass = className => document.body.classList.add(className);
  const removeBodyClass = className => document.body.classList.remove(className);

  useEffect(() => {
    const show = async () => {
      if (hasAnswered) {
        // show the screen after 1 second
        await wait(1000);
        addBodyClass('fade-in-correct');

        return () => {
          removeBodyClass('fade-in-correct');
        };
      }
    };
    show();
  }, [hasAnswered]);

  const handleAnswer = (isCorrect) => {
    if(isCorrect) {
      setHasAnswered(true)
      addScore(score);
    }
    else {
      setScore(score-1);
    }
  }

  // attach the main.js file
 useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/main.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // attach the jquery.nicescroll.min.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/jquery.nicescroll.min.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    trackGTMEvent(2);
  }, []);

  return (
    <main>
      <section className="question type-1">
        <div className="inner">
          <ScoreBoard />
          <ProgressBar question={2} />
          <SecurityExpert text={t('questions.2.expert')}/>

          <MobileVideoButton className="q2" />
          <VideoFilesFullLoop page='q2' id='q2-video' />

          <div className="loop-screen q2" />
          <SkipVideo />

          <div className="question-wrapper">
            <h1 className="question2-text">{t('questions.2.title')}</h1>
            <div className="select">
              <MultipleChoiceAnswer text={t('questions.2.answers.A')} symbol={'A'} isCorrect={false} onClick={handleAnswer} />
              <MultipleChoiceAnswer text={t('questions.2.answers.B')} symbol={'B'} isCorrect={false} onClick={handleAnswer} />
              <MultipleChoiceAnswer text={t('questions.2.answers.C')} symbol={'C'} isCorrect={false} onClick={handleAnswer} />
              <MultipleChoiceAnswer text={t('questions.2.answers.D')} symbol={'D'} isCorrect={true} onClick={handleAnswer} />
            </div>
          </div>

          {hasAnswered && (
            <CorrectAnswer question={2} isPlaying={hasAnswered} scoreTier={5 - score} />
          )}

        </div>
      </section>
    </main>
  );
};

export default Question2;
